import React from 'react';
import {useTranslation} from 'react-i18next';
import {MapContainer, Marker, Popup, TileLayer} from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import './DetailsMapSection.scss';

delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

interface DetailsMapSectionProps {
  latitude?: number;
  longitude?: number;
  title?: string;
  placeName?: string;
}

const DetailsMapSection: React.FC<DetailsMapSectionProps> = ({
  latitude,
  longitude,
                                                               title,
  placeName
}) => {
  const {t} = useTranslation();
  const displayTitle = title || t('details.sections.location');

  if (latitude == null || longitude == null) {
    return null;
  }

  const position: [number, number] = [latitude, longitude];

  return (
    <div id="map-card" className="bg-white shadow-sm p-6">
      <h3 className="text-lg font-semibold text-stone-900 mb-4">{displayTitle}</h3>
      <div className="map-container">
        <MapContainer
          center={position}
          zoom={15}
          scrollWheelZoom={true}
          className="details-map"
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Marker position={position}>
            {placeName && (
              <Popup>
                {placeName}
              </Popup>
            )}
          </Marker>
        </MapContainer>
      </div>
    </div>
  );
};

export default DetailsMapSection;

